module.exports = __webpack_public_path__ + "static/the-opal-dragonfly-85d0771b7cdeae1e947b8df0232674e3.jpg";